export type EvidenceUpgradeModalTarget = 'clinician' | 'practice';

export function resolveEvidenceUpgradeModalTarget({
  isScribePlusUser,
  isClinicianTrialUser,
  isPracticeUpgradeTarget,
}: {
  isScribePlusUser: boolean;
  isClinicianTrialUser: boolean;
  isPracticeUpgradeTarget: boolean;
}): EvidenceUpgradeModalTarget {
  if (isScribePlusUser || isClinicianTrialUser) {
    return 'clinician';
  }

  if (isPracticeUpgradeTarget) {
    return 'practice';
  }

  // Evidence Plus upgrade paths retired (GRO-3609) — always Clinician.
  return 'clinician';
}
